import React from "react";
import { motion } from "framer-motion";
import { formatCurrency } from "soft_digi/dist/services/CommonService";
import { SmartTable, SmartTableNewInterface } from "soft_digi";

// Sample data
const invoices = [
  { number: "INV-1001", amount: 250.75 },
  { number: "INV-1002", amount: 499.99 },
  { number: "INV-1003", amount: 120.00 },
  { number: "INV-1004", amount: 875.50 },
  { number: "INV-1005", amount: 300.00 }
];
interface HubsViewProps {
  table_data: any;
}
const VendorWiseDetails: React.FC<HubsViewProps> = ({table_data}) => {

    const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
      { title: "S.NO", index: "s_no", type: "sno", width: "5" },
      // {
      //   title: "Vendor",
      //   index: "vendor_name",
      // },
      {
        title: "Invoices No.",
        index: "invoice_number",
      },
  
      {
        title: " Total Amount",
        index: "total_amount",
        type: "currency",
      },
      {
        title: "Paid Amount",
        index: "paid_amount",
        type: "currency",
      },
      // {
      //   title: "Pending",
      //   index: "pending_amount",
      //   type: "currency",
      // }, backend Changed
      {
        title: "Remaining Amount",
        index: "remaining_amount",
        type: "currency",
      },
     
    ];
  return (
    <div className="box">
     
      {/* <table className="table is-fullwidth is-striped">
        <tbody>
          {table_data?.map((invoice: any, index: number) => (
            <motion.tr
              key={invoice.number}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <td className="has-text-left has-text-weight-semibold">{invoice.invoice_number}</td>
              <td className="has-text-right has-text-weight-bold">{formatCurrency(invoice.total_amount) }</td>
            </motion.tr>
          ))}
        </tbody>
      </table> */}
      <div className="smart-elf-table">
        <SmartTable
          columns={columns}
          data={table_data}
          tableProps={{
            className: " is-hoverable is-bordered is-striped smart-efl-table",
            isResponsive: true,
            searchPlaceHolder: "Search",
          }}
          paginationProps={{
            pageSize: 10,
          }}
        />
      </div>
    </div>
  );
};




export default VendorWiseDetails